// Mock Data for Red Interreligiosa Zárate
// Future API endpoint: GET /api/red/content

export const siteInfo = {
  name: "Red Interreligiosa de Protección Integral y Restitución de Derechos Zárate",
  subtitle: "Articulación comunitaria, social, espiritual e institucional para promover la dignidad humana y la restitución de derechos en Zárate.",
  slogan: "Unidad · Dignidad · Justicia · Acción",
  lema: "Unidos por la dignidad humana, comprometidos con la justicia social.",
  phone: "+54 9 3487-392859",
  email: "redinterreligiosazarate@gmail.com",
  address: "Colectora Oeste Nº 900, Zárate, Provincia de Buenos Aires, Argentina",
  foundedYear: 2018,
  mission: "Promover acciones integrales de asistencia, contención, prevención, acompañamiento y restitución de derechos mediante el trabajo articulado entre instituciones religiosas, organizaciones civiles y organismos del Estado.",
  vision: "Constituirse como una red de referencia local, provincial y nacional en materia de articulación interreligiosa y acción comunitaria, impulsando políticas de inclusión y protección integral.",
  identity: "La Red Interreligiosa de Protección Integral y Restitución de Derechos – Zárate nace como un espacio de articulación comunitaria, social, espiritual e institucional destinado a promover la dignidad humana, la protección integral y la restitución de derechos de las personas en situación de vulnerabilidad. Inspirada en los valores universales de la solidaridad, la justicia, la paz, la compasión y el respeto mutuo, reúne a distintas expresiones religiosas, organizaciones sociales, instituciones comunitarias y organismos públicos.",
  cbu: "0000003100055762769920",
  alias: "red.interreligiosa.z",
  mercadoPagoLink: "https://link.mercadopago.com.ar/redinterreligiosa",
  linea145: "145"
};

export const coreValues = [
  "Respeto por la dignidad humana",
  "Solidaridad y empatía",
  "Justicia social",
  "Igualdad de oportunidades",
  "Inclusión social",
  "Cooperación institucional",
  "Diálogo interreligioso",
  "Defensa de los derechos humanos",
  "Transparencia y compromiso",
  "Cultura de paz"
];

export const strategicObjectives = [
  {
    id: 1,
    title: "Protección Integral",
    description: "Contención, asistencia y acompañamiento a personas y familias en situación de vulnerabilidad.",
    icon: "ShieldCheck"
  },
  {
    id: 2,
    title: "Restitución de Derechos",
    description: "Acceso efectivo a derechos fundamentales, igualdad de oportunidades e inclusión social.",
    icon: "Scale"
  },
  {
    id: 3,
    title: "Articulación Institucional",
    description: "Coordinación con organismos municipales, provinciales, nacionales y organizaciones civiles.",
    icon: "Building2"
  },
  {
    id: 4,
    title: "Diálogo Interreligioso",
    description: "Respeto mutuo, paz social y convivencia democrática entre distintas expresiones de fe.",
    icon: "Handshake"
  },
  {
    id: 5,
    title: "Acción Territorial",
    description: "Presencia comunitaria en los barrios de Zárate con campañas y redes de acompañamiento.",
    icon: "MapPin"
  }
];

export const workAreas = [
  {
    id: 1,
    title: "Social y Comunitaria",
    items: ["Coordinación territorial", "Asistencia social", "Programas solidarios", "Acompañamiento comunitario", "Redes barriales"],
    icon: "Users"
  },
  {
    id: 2,
    title: "Derechos Humanos",
    items: ["Promoción de derechos", "Asistencia y orientación", "Articulación institucional", "Acompañamiento de víctimas", "Prevención de vulneraciones"],
    icon: "Scale"
  },
  {
    id: 3,
    title: "Prevención y Protección",
    items: ["Prevención de violencias", "Consumos problemáticos", "Protección de niñez", "Prevención de trata", "Protocolos de intervención"],
    icon: "ShieldCheck"
  },
  {
    id: 4,
    title: "Diálogo Interreligioso",
    items: ["Relaciones interreligiosas", "Actividades ecuménicas", "Construcción de convivencia", "Jornadas de paz", "Diversidad cultural y religiosa"],
    icon: "Handshake"
  },
  {
    id: 5,
    title: "Educación y Formación",
    items: ["Capacitaciones", "Formación comunitaria", "Talleres educativos", "Seminarios y jornadas", "Liderazgo comunitario"],
    icon: "BookOpen"
  },
  {
    id: 6,
    title: "Juventud y Familia",
    items: ["Programas juveniles", "Contención familiar", "Actividades recreativas", "Prevención social", "Espacios de orientación"],
    icon: "HeartHandshake"
  }
];

export const programs = [
  {
    id: "01",
    title: "Asistencia Integral Comunitaria",
    description: "Brindar asistencia inmediata y acompañamiento integral a personas y familias en situación de vulnerabilidad.",
    actions: ["Entrega de alimentos", "Asistencia de emergencia", "Redes de acompañamiento", "Derivaciones institucionales", "Contención social y emocional"]
  },
  {
    id: "02",
    title: "Prevención y Protección de Derechos",
    description: "Fortalecer la prevención de situaciones de violencia, exclusión y vulneración de derechos.",
    actions: ["Talleres preventivos", "Capacitaciones comunitarias", "Campañas de concientización", "Intervención comunitaria", "Articulación institucional"]
  },
  {
    id: "03",
    title: "Interreligioso de Paz y Convivencia",
    description: "Promover la convivencia democrática y el respeto mutuo entre las distintas expresiones religiosas y culturales.",
    actions: ["Encuentros interreligiosos", "Jornadas de paz", "Actividades comunitarias", "Espacios de diálogo", "Eventos culturales"]
  },
  {
    id: "04",
    title: "Territorial Barrial",
    description: "Fortalecer la presencia comunitaria de la Red en los distintos barrios de Zárate.",
    actions: ["Operativos barriales", "Redes comunitarias", "Relevamientos territoriales", "Campañas solidarias", "Actividades integrales"]
  },
  {
    id: "05",
    title: "Prevención de Trata y Violencias",
    description: "Desarrollar acciones preventivas, educativas y de acompañamiento frente a situaciones de trata, explotación y violencia.",
    actions: ["Campañas de sensibilización", "Capacitación institucional", "Redes de derivación", "Articulación con organismos especializados", "Acompañamiento a víctimas"]
  }
];

export const trataInfo = {
  title: "Prevención de Trata y Violencias",
  intro: "Área especializada de la Red que interviene frente a situaciones de trata de personas, violencia de género, explotación infantil, violencia institucional y delitos conexos contra los derechos humanos.",
  intervention: [
    "Trata de personas",
    "Violencia de género",
    "Explotación infantil",
    "Violencia institucional",
    "Delitos conexos contra derechos humanos"
  ],
  actions: [
    "Mesas de trabajo interdisciplinarias",
    "Campañas de prevención y sensibilización",
    "Capacitaciones comunitarias",
    "Redes de derivación y asistencia",
    "Acompañamiento integral a víctimas",
    "Coordinación con organismos especializados",
    "Fortalecimiento de protocolos de intervención",
    "Cooperación con programas provinciales y nacionales"
  ],
  helpLine: {
    number: "145",
    label: "Línea Nacional contra la Trata de Personas",
    detail: "Gratuita, 24 horas, confidencial."
  }
};

export const communityActions = [
  {
    title: "Campañas Solidarias",
    items: ["Recolección de alimentos", "Campañas de abrigo", "Donaciones solidarias", "Asistencia escolar", "Ayuda de emergencia"]
  },
  {
    title: "Jornadas Comunitarias",
    items: ["Operativos integrales", "Ferias solidarias", "Actividades recreativas", "Charlas y talleres", "Jornadas de salud comunitaria"]
  },
  {
    title: "Capacitaciones",
    items: ["Derechos humanos", "Violencia familiar", "Prevención de adicciones", "Trata de personas", "Inclusión social", "Diversidad y convivencia"]
  }
];

export const alliances = [
  "Municipalidad de Zárate",
  "Organismos provinciales",
  "Áreas nacionales",
  "Instituciones religiosas",
  "Organizaciones sociales",
  "Universidades y centros educativos",
  "Hospitales y centros de salud",
  "Organismos de derechos humanos",
  "Redes nacionales e internacionales"
];

export const socialImpact = [
  "Fortalecer el tejido social comunitario",
  "Generar espacios de paz y convivencia",
  "Incrementar la asistencia y contención social",
  "Mejorar la articulación institucional",
  "Promover derechos e inclusión",
  "Fortalecer la prevención de violencias",
  "Potenciar la participación ciudadana",
  "Construir una comunidad más solidaria y humana"
];

export const contactReasons = [
  "Solicitar asistencia",
  "Deseo colaborar",
  "Solicitar información",
  "Denuncia o alerta",
  "Otro motivo"
];

export const leaders = [
  {
    id: 1,
    name: "Hna. María Beatriz Morales",
    tradition: "Iglesia Católica - Cáritas Argentina",
    role: "Coordinadora de Protección Integral y Cáritas",
    bio: "Destacada referente en Cáritas Argentina y acción social, lidera programas de restitución de derechos, asistencia alimentaria y contención familiar en Zárate.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=600"
  },
  {
    id: 2,
    name: "Rabino Daniel Sztutwojn",
    tradition: "Comunidad Judía",
    role: "Referente Espiritual Judaico",
    bio: "Lidera encuentros interreligiosos de reflexión sobre los textos sagrados, ética social y la memoria compartida.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=600"
  },
  {
    id: 3,
    name: "Pastor Samuel Benítez",
    tradition: "Iglesia Evangélica",
    role: "Coordinador Pastoral y Comunitario",
    bio: "Trabaja activamente en comedores comunitarios, contención juvenil y jornadas de oración por la unidad de la ciudad.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=600"
  },
  {
    id: 4,
    name: "Pr. Marcos Orellana",
    tradition: "Iglesia Adventista del Séptimo Día",
    role: "Referente de Salud Integral y Educación",
    bio: "Impulsor de ferias de salud comunitaria, educación familiar y programas de prevención y bienestar integral.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=600"
  },
  {
    id: 5,
    name: "Élder Alejandro R. Valenzuela",
    tradition: "Iglesia de Jesucristo de los Santos de los Últimos Días",
    role: "Coordinador de Ayuda Humanitaria y Autosuficiencia",
    bio: "Coordinador de proyectos de ayuda humanitaria de emergencia, donación de insumos médicos y capacitación comunitaria.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=600"
  },
  {
    id: 6,
    name: "Hno. Tenzin Norbu",
    tradition: "Tradición Budista / Zen",
    role: "Referente de Meditación y Paz",
    bio: "Facilitador de círculos de silencio, atención plena y ética universal en Zárate.",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=600"
  }
];

export const events = [
  {
    id: 1,
    title: "Encuentro Anual de Oración por la Paz",
    date: "13 de Noviembre, 2026",
    time: "20:00 Hs",
    location: "Plaza Mitre, Zárate",
    category: "Encuentro Público",
    description: "Marcha nocturna con velas encendidas y reunión abierta a toda la comunidad donde representantes de todos los credos comparten plegarias, cantos corales y mensajes de fraternidad por la paz.",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_comunidad-dialogos/artifacts/6w0dhda5_oracion.png",
    attendees: 142
  },
  {
    id: 2,
    title: "Jornada de Sensibilización contra la Trata de Personas",
    date: "23 de Septiembre, 2026",
    time: "18:00 Hs",
    location: "Salón Auditorio Municipal, Zárate",
    category: "Prevención",
    description: "Capacitación abierta a la comunidad sobre identificación, prevención y denuncia de la trata de personas. Difusión de la Línea 145.",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_comunidad-dialogos/artifacts/lr235mg0_Jornada%20capacitacion.png",
    attendees: 180
  },
  {
    id: 3,
    title: "Jornada de Diálogo: 'Ética y Cuidado de la Casa Común'",
    date: "28 de Octubre, 2026",
    time: "19:00 Hs",
    location: "Salón Auditorio Municipal, Zárate",
    category: "Seminario / Foro",
    description: "Conversatorio interreligioso sobre la responsabilidad ecológica y el cuidado del ambiente desde las distintas tradiciones.",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_comunidad-dialogos/artifacts/9edawtwe_etica%20y%20cuidado%20ambiente.png",
    attendees: 85
  },
  {
    id: 4,
    title: "Cena Solidaria Interreligiosa Anual",
    date: "12 de Noviembre, 2026",
    time: "20:30 Hs",
    location: "Club Náutico Zárate",
    category: "Solidaridad",
    description: "Evento benéfico destinado a recaudar fondos para merenderos y programas de asistencia integral coordinados por la Red.",
    image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&q=80&w=800",
    attendees: 210
  },
  {
    id: 5,
    title: "Seminario de Mediación y Resolución de Conflictos",
    date: "03 de Diciembre, 2026",
    time: "17:00 Hs",
    location: "Centro Cultural Círculo",
    category: "Capacitación",
    description: "Herramientas prácticas para líderes comunitarios sobre comunicación no violenta y diálogo constructivo.",
    image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&q=80&w=800",
    attendees: 64
  }
];

export const documents = [
  {
    id: 1,
    title: "Declaración Conjunta sobre Convivencia Pacífica 2026",
    date: "10 de Enero, 2026",
    category: "Comunicado Oficial",
    description: "Manifiesto firmado por todas las comunidades que integran la Red comprometiéndose a velar por el respeto mutuo en Zárate.",
    fileType: "PDF",
    fileSize: "1.2 MB",
    downloads: 412
  },
  {
    id: 2,
    title: "Protocolo de Actuación frente a Casos de Trata",
    date: "20 de Julio, 2025",
    category: "Protocolo",
    description: "Guía interinstitucional con pasos a seguir en la detección, derivación y acompañamiento de posibles víctimas de trata de personas.",
    fileType: "PDF",
    fileSize: "1.8 MB",
    downloads: 275
  },
  {
    id: 3,
    title: "Estatutos y Principios Fundacionales de la Red",
    date: "14 de Mayo, 2018",
    category: "Documento Institucional",
    description: "Normas de funcionamiento interno, objetivos a largo plazo y código ético de participación interreligiosa.",
    fileType: "PDF",
    fileSize: "2.4 MB",
    downloads: 830
  },
  {
    id: 4,
    title: "Guía de Buenas Prácticas para el Diálogo Intercultural",
    date: "22 de Agosto, 2025",
    category: "Educativo",
    description: "Material pedagógico para escuelas, centros vecinales y organizaciones civiles sobre diversidad religiosa y convivencia.",
    fileType: "PDF",
    fileSize: "3.1 MB",
    downloads: 654
  },
  {
    id: 5,
    title: "Mensaje Especial por la Semana de la Fraternidad",
    date: "05 de Marzo, 2026",
    category: "Carta Abierta",
    description: "Reflexión conjunta acerca de los desafíos éticos contemporáneos y la esperanza en la acción solidaria.",
    fileType: "PDF",
    fileSize: "850 KB",
    downloads: 320
  }
];

export const newsArticles = [
  {
    id: 1,
    title: "Reuniones interreligiosas con líderes locales y provinciales",
    date: "20 de Junio, 2026",
    excerpt: "Referentes de las distintas comunidades religiosas mantuvieron encuentros de articulación con autoridades municipales y provinciales para coordinar acciones conjuntas de protección integral y restitución de derechos.",
    category: "Institucional",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_comunidad-dialogos/artifacts/gsn8x5sv_mesa%20de%20coordinacion.png"
  },
  {
    id: 2,
    title: "Se celebra una vez más el Día Internacional de la Paz",
    date: "21 de Septiembre, 2026",
    excerpt: "La Red convoca a toda la comunidad a la celebración del Día Internacional de la Paz frente al municipio, con encendido de velas, cantos corales y mensajes de unidad y fraternidad de las distintas tradiciones.",
    category: "Eventos",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_comunidad-dialogos/artifacts/m9mnq0ln_red%20por%20la%20paz.png"
  },
  {
    id: 3,
    title: "Convenios que transforman solidaridad en acción",
    date: "12 de Junio, 2025",
    excerpt: "La Red Interreligiosa impulsa la firma de convenios con redes y organizaciones nacionales e internacionales para fortalecer la ayuda alimentaria humanitaria y llegar a quienes más lo necesitan. A través del trabajo conjunto, buscamos construir puentes de cooperación, solidaridad y compromiso social. \"Dar es recibir. Unidos, multiplicamos la esperanza.\"",
    category: "Solidaridad",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_comunidad-dialogos/artifacts/5nrepnhe_firma%20de%20convenio.png"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Participar en la Red Interreligiosa me ha demostrado que tenemos mucho más en común de lo que pensamos. La paz se construye cada día con pequeños gestos de escucha.",
    author: "María Elena Rossi",
    role: "Vecina y Colaboradora"
  },
  {
    id: 2,
    quote: "Zárate es un ejemplo de convivencia armónica. Aquí las diferencias religiosas no son motivo de división, sino una riqueza que enriquece nuestra cultura ciudadana.",
    author: "Dr. Esteban M. Fuentes",
    role: "Historiador local"
  }
];
